var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-button',{attrs:{"color":"danger","size":"small","icon-pack":"feather","icon":"icon-trash-2","disabled":!_vm.canBeDeleted},nativeOn:{"click":function($event){return _vm.removeFieldMapping(_vm.rowIndex)}}})}
var staticRenderFns = []

export { render, staticRenderFns }